import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app/App";
import { requireElement } from "@/lib/utils";
import "@/styles/globals.css";

const rootEl = requireElement(document.getElementById("root"), "#root");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
